export const GET_PRODUCT_REQUEST = "GET_PRODUCT_REQUEST";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAILURE = "GET_PRODUCT_FAILURE";
export const ADD_PRODUCT_REQUEST='ADD_PRODUCT_REQUEST';
export const ADD_PRODUCT_SUCCESS='ADD_PRODUCT_SUCCESS';
export const ADD_PRODUCT_FAILURE='ADD_PRODUCT_FAILURE';
export const DELETE_PRODUCT_REQUEST='DELETE_PRODUCT_REQUEST';
export const DELETE_PRODUCT_SUCCESS='DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAILURE='DELETE_PRODUCT_FAILURE';
export const UPDATE_PRODUCT_REQUEST='UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_SUCCESS='UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAILURE='UPDATE_PRODUCT_FAILURE';

export const GET_USERLIST_REQUEST='GET_USERLIST_REQUEST';
export const GET_USERLIST_SUCCESS='GET_USERLIST_SUCCESS';
export const GET_USERLIST_FAILURE='GET_USERLIST_FAILURE';
export const DELETE_USER_REQUEST='DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS='DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE='DELETE_USER_FAILURE';
export const GET_ADMINLIST_REQUEST='GET_ADMINLIST_REQUEST';
export const GET_ADMINLIST_SUCCESS='GET_ADMINLIST_SUCCESS';
export const GET_ADMINLIST_FAILURE='GET_ADMINLIST_FAILURE';
export const ADD_ADMIN_REQUEST='ADD_ADMIN_REQUEST';
export const ADD_ADMIN_SUCCESS='ADD_ADMIN_SUCCESS';
export const ADD_ADMIN_FAILURE='ADD_ADMIN_FAILURE';
export const DELETE_ADMIN_REQUEST='DELETE_ADMIN_REQUEST';
export const DELETE_ADMIN_SUCCESS='DELETE_ADMIN_SUCCESS';
export const DELETE_ADMIN_FAILURE='DELETE_ADMIN_FAILURE';